import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import { observer } from "mobx-react";
import HomeStore from "../stores/HomeStore";
import JobsFilter from "./HomePage/JobsFilter";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import JobsTable from "./HomePage/JobsTable";
import ContentLoader from "~/components/element/ContentLoader";
import NoJobs from "./HomePage/NoJobs";
import PaginatedTable from "~/components/PaginatedTable";

import "../styles/Home.less";

@observer
class HomePage extends Component {
  homeStore = null;

  constructor(props) {
    super(props);
    this.homeStore = new HomeStore({ tourId: props.tourId });
  }

  componentDidMount() {
    const { showError, showCreateJobPageCallback } = this.props;
    this.homeStore
      .load()
      .then(() => {
        // redirect to Create Job Page if there are no existing jobs
        if (this.homeStore.photoEditingJobs.length === 0) {
          showCreateJobPageCallback();
        }
      })
      .catch(error => showError(error.message));
  }

  render() {
    const { isLoading, photoEditingJobs, hasPhotoEditingJobs, pagination } = this.homeStore;
    const { showError, hideTourColumn, viewJobCallback, showCreateJobPageCallback } = this.props;

    if (isLoading) {
      return <ContentLoader />;
    }

    if (!hasPhotoEditingJobs) {
      return <NoJobs onClick={() => showCreateJobPageCallback()} />;
    }

    return (
      <Grid className="home">
        <Grid.Row className="no-overflow">
          <Grid.Column>
            <h2>HDR jobs</h2>
            <JobsFilter
              status={this.homeStore.status}
              statusOptions={HomeStore.getStatusOptions()}
              onStatusChange={status => this.homeStore.onStatusChange(status)}
              query={this.homeStore.query}
              onQueryChange={query => this.homeStore.onQueryChange(query)}
              onSearchClick={() => this.homeStore.searchPhotoEditingJobs().catch(error => showError(error.message))}
              onCreatePhotoEditingJobClick={() => showCreateJobPageCallback()}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ minHeight: "500px" }}>
          <Grid.Column>
            <PaginatedTable
              totalItemsCount={photoEditingJobs.length}
              pagination={pagination}
              changePageCallback={page => this.homeStore.changePage(page).catch(error => showError(error.message))}
            >
              <JobsTable
                photoEditingJobs={photoEditingJobs}
                hideTourColumn={hideTourColumn}
                deletePhotoEditingJobCallback={photoEditingJobId =>
                  this.homeStore.deletePhotoEditingJob(photoEditingJobId).catch(error => showError(error.message))
                }
                viewJobCallback={viewJobCallback}
              />
            </PaginatedTable>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

HomePage.propTypes = {
  tourId: PropTypes.number,
  showError: PropTypes.func.isRequired,
  hideTourColumn: PropTypes.bool,
  showCreateJobPageCallback: PropTypes.func.isRequired,
  // callback in order to render the View Job page.
  viewJobCallback: PropTypes.func,
};

export default ErrorWrapper(HomePage);
